<section class="w-full">
    <split-header-section title="Liberações">

    </split-header-section>
    <div class="bg-white border-round-2xl p-5">
        <split-inside-menu [data]="insideMenuData" (currentIndex)="setItemMenuIndex($event)">
        </split-inside-menu>
    </div>

    <div class="mt-5">
        <split-card>
            <div *ngIf="itemMenuIndex == 0" card-body>
                <split-table card-body [checklist]="false" [widthColumns]="[95, 5]" theme="primary">
                    <ng-template #header> <span class="header-title">Tipo</span> </ng-template>
                    <ng-template #header></ng-template>

                    <ng-template #linha>
                        <div class="w-full border-bottom" style="display: table">
                            <td class="text-left title py-5">

                                <span class="ml-6">
                                    Telemedicina
                                </span>

                            </td>
                            <td>
                                <div class="flex justify-content-end mr-6">
                                    <form [formGroup]="releaseForm">
                                        <p-inputSwitch formControlName="telemedicina"
                                            (onChange)="openConfirmationDialog('Telemedicina')"></p-inputSwitch>
                                    </form>
                                </div>
                            </td>
                        </div>
                    </ng-template>

                </split-table>
            </div>

            <div *ngIf="itemMenuIndex == 1" card-body>
                <split-table card-body [checklist]="false" [widthColumns]="[95, 5]" theme="primary">
                    <ng-template #header> <span class="header-title">Tipo</span> </ng-template>
                    <ng-template #header></ng-template>

                    <ng-template #linha>
                        <div class="w-full border-bottom" style="display: table">
                            <td class="text-left title py-5">

                                <span class="ml-6">
                                    Receituário e evolução
                                </span>

                            </td>
                            <td>
                                <div class="flex justify-content-end mr-6">
                                    <form [formGroup]="releaseForm">
                                        <p-inputSwitch formControlName="receituarioEvolucao"
                                            (onChange)="openConfirmationDialog('ReceituarioEvolucao')"></p-inputSwitch>
                                    </form>
                                </div>
                            </td>
                        </div>


                    </ng-template>

                </split-table>
            </div>

            <div *ngIf="itemMenuIndex == 2" card-body>
                <split-table card-body [checklist]="false" [widthColumns]="[95, 5]" theme="primary">
                    <ng-template #header> <span class="header-title">Tipo</span> </ng-template>
                    <ng-template #header></ng-template>

                    <ng-template #linha>
                        <div class="w-full border-bottom" style="display: table">
                            <td class="text-left title py-5">

                                <span class="ml-6">
                                    Widget site
                                </span>

                            </td>
                            <td>
                                <div class="flex justify-content-end mr-6">
                                    <button class="copy"> <span class="button_label">COPIAR CÓDIGO</span> </button>
                                </div>
                            </td>
                        </div>
                    </ng-template>


                </split-table>

                <div class="py-3">
                    <a href="" class="widget "> Como adicionar meu widget? </a>
                </div>
            </div>

            <div *ngIf="itemMenuIndex == 3" card-body>

                <form [formGroup]="triggerForm">

                    <table class="w-full" style="border-collapse: collapse;">
                        <colgroup>
                            <col style="width: 50%;">
                            <col style="width: 15%;">
                            <col style="width: 15%;">
                            <col style="width: 20%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text-left ">
                                    <span class="ml-6">Tipo</span>
                                </th>

                                <th>
                                    Disparo
                                </th>

                                <th>
                                    Veículos
                                </th>

                                <th>
                                    Liberação
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-bottom">
                                <ng-container formGroupName="enableReviews">
                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Avaliações
                                        </span>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="trigger"
                                                [options]="[{label: 'Automático'}, {label: 'Manual'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>

                                        </div>


                                    </td>
                                </ng-container>
                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="enable24hConfirmation">
                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Confirmação 24h
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">

                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>
                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="enable48hConfirmation">


                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Confirmação 48h
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>


                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>


                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">

                                <ng-container formGroupName="enable72hConfirmation">
                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Confirmação 72h
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">

                                <ng-container formGroupName="enableManualConfirmation">


                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Confirmação disparo manual
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">

                                <ng-container formGroupName="sendDataAfterBooking">

                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Dados consulta após agendar
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>


                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="sendScheduleReminders">

                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Informar agenda profissional
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>


                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="sendDayBeforeReminder">
                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Lembrete dia anterior 15h
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>
                            </tr>

                            <tr class="border-bottom">

                                <ng-container formGroupName="nextAppointmentReminder">

                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Lembrete próxima consulta
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="waitingListNotification">

                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Lista espera disparo
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                            <tr class="border-bottom">
                                <ng-container formGroupName="appointmentCancellationNotification">

                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Notificação cancelamento de consulta
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades" [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>

                                </ng-container>
                            </tr>

                            <tr class="border-bottom">

                                <ng-container formGroupName="appointmentPreconfirmation">


                                    <td class="text-left title py-5">

                                        <span class="ml-6">
                                            Pré Confirmação
                                        </span>

                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-dropdown class="m-auto" formControlName="channel"
                                                [options]="[{label: 'Whatsapp'}, {label: 'SMS'}]"
                                                optionLabel="label"></p-dropdown>
                                        </div>

                                    </td>
                                    <td>
                                        <div class="flex">
                                            <p-multiSelect class="m-auto" formControlName="units"
                                                placeholder="Selecionar Unidades"
                                                [options]="(listaUnidades$ | async)!"
                                                optionLabel="unitName"></p-multiSelect>
                                        </div>

                                    </td>
                                </ng-container>

                            </tr>

                        </tbody>
                    </table>

                    <div class="w-full flex justify-content-end align=align-items-center mt-6">
                        <button class="save" (click)="openConfirmationDialog('AgendaDisparos')">
                            <span class="button_save_label">Salvar</span>
                        </button>
                    </div>

                </form>
            </div>

            <div *ngIf="itemMenuIndex == 4" card-body>
                <split-table card-body [checklist]="false" [widthColumns]="[95, 5]" theme="primary">
                    <ng-template #header> <span class="header-title">Tipo</span> </ng-template>
                    <ng-template #header></ng-template>

                    <ng-template #linha>
                        <div class="w-full border-bottom" style="display: table">
                            <td class="text-left title py-5">

                                <span class="ml-6">
                                    Telefonia em nuvem
                                </span>

                            </td>
                            <td>
                                <div class="flex justify-content-end mr-6">
                                    <form [formGroup]="releaseForm">
                                        <p-inputSwitch formControlName="telefoniaNuvem"
                                            (onChange)="openConfirmationDialog('Telefonia')"></p-inputSwitch>
                                    </form>
                                </div>
                            </td>
                        </div>
                    </ng-template>

                </split-table>
            </div>
        </split-card>
    </div>


</section>


<!-- dialog de confirmação -->

<p-dialog [(visible)]="mostrarConfirmarTelemedicina" [closable]="false" [dismissableMask]="true" styleClass="pDialog"
    [draggable]="false" [modal]="true">
    <div class="content">
        <span class="title">
            <p>Você confirma a liberação de</p>
            <p>Telemedicina?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você pagará uma taxa de R$15,00</p>
            <p>para realizar sua aprovação.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="onCancel('telemedicina')">Cancelar</button>
        <button class="confirmar" (click)="onSubmit('telemedicina')">Confirmar</button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="mostrarConfirmarReceituarioEvolucao" [closable]="false" [dismissableMask]="true"
    styleClass="pDialog" [draggable]="false" [modal]="true">
    <div class="content">
        <span class="title">
            <p>Você confirma a liberação de</p>
            <p>Receituário e Evolução?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você pagará uma taxa de R$15,00</p>
            <p>para realizar sua aprovação.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="onCancel('receituario_evolucao')">Cancelar</button>
        <button class="confirmar" (click)="onSubmit('receituario_evolucao')">Confirmar</button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="mostrarConfirmarTelefonia" [closable]="false" [dismissableMask]="true" styleClass="pDialog"
    [draggable]="false" [modal]="true">
    <div class="content">
        <span class="title">
            <p>Você confirma a liberação de</p>
            <p>Telefonia?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você pagará uma taxa de R$15,00</p>
            <p>para realizar sua aprovação.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="onCancel('telefonia_nuvem')">Cancelar</button>
        <button class="confirmar" (click)="onSubmit('telefonia_nuvem')">Confirmar</button>
    </ng-template>
</p-dialog>

<!-- inicio dialog de confirmação dos disparos -->

<p-dialog [(visible)]="mostrarConfirmarAgendaDisparos" [closable]="false" [dismissableMask]="true" styleClass="pDialog"
    [draggable]="false" [modal]="true">
    <div class="content">
        <span class="title">
            <p>Você confirma suas opções</p>
            <p>de disparo?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você pagará uma taxa de R$15,00</p>
            <p>para realizar sua programação.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="onCancel('disparos')">Cancelar</button>
        <button class="confirmar" (click)="onSubmit('disparos')">Confirmar</button>
    </ng-template>
</p-dialog>

<!-- fim dialog de confirmação dos disparos -->